import * as z from "zod/v4";

export const stopMarketingAgentTest = {
  name: "stopMarketingAgentTest" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
